import gql from 'graphql-tag';

export const publishMutation = gql`
  mutation publishToFeed($itemId: String!, $platforms: [String]) {
    publishToFeed(feedItemId: $itemId, platforms: $platforms)
  }
`;
